export enum ContentType {
    CONTENT = "content",
    MEAL = "meal",
    WORKOUT = "workout"
}